export type Shade = 700 | 600 | 500 | 400 | 300 | 200 | 100 | 50 | 25
export type ThemeName = 'purple' | 'darkBlue' | 'mint' | 'burgundy' | 'orange' | 'lightblue'

export interface SwatchValue {
  hex: string
  stop: number
  h: number
  hScale: number
  s: number
  sScale: number
  l: number
}

export type Mode = `hex` | `p-3` | `oklch` | `hsl`

export type ColorMode = 'linear' | 'perceived'

export type StopSelection = 'auto' | 'manual'

export interface PaletteConfig {
  id: string
  name: string
  value: string
  valueStop: number
  swatches: SwatchValue[]
  colorMode: ColorMode
  h: number
  s: number
  lMin: number
  lMax: number
  mode: Mode
  stopSelection: StopSelection
}

export const MODES: Mode[] = [`hex`, `oklch`, `p-3`, `hsl`]
export const DEFAULT_STOP = 500
export const DEFAULT_PALETTE_CONFIG: PaletteConfig = {
  id: ``,
  name: ``,
  value: ``,
  valueStop: DEFAULT_STOP,
  swatches: [],
  h: 0,
  s: 0,
  lMin: 0,
  lMax: 100,
  colorMode: 'perceived',
  mode: MODES[0],
  stopSelection: 'auto',
}

/**
 * Simple example API for generating a Tailwind-like palette from an input color
 * and a target stop (e.g., 500). This function reuses the original
 * createSwatches algorithm to ensure output parity, and returns a simplified
 * swatch shape (stop + hex only).
 *
 * Usage:
 *   const palette = simpleGeneratePalette("1E70F6", 500, { colorMode: "perceived" });
 */
export type SimplePaletteConfig = {
  /**
   * Hue tweak per step away from the target stop (in degrees)
   */
  h?: number
  /**
   * Saturation tweak per step away from the target stop (0-100 domain)
   */
  s?: number
  /**
   * Maximum lightness at stop 0 (0-100)
   */
  lMax?: number
  /**
   * Minimum lightness at stop 1000 (0-100)
   */
  lMin?: number
  /**
   * Whether to use perceived lightness (HSLuv) or linear HSL
   */
  colorMode?: PaletteConfig['colorMode']
}
